import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import NoticeDetailModal from './noticeDetailModal';

const CATEGORY_BORDER = { General: '#94A3B8', Incentive: '#F59E0B', News: '#1A8CFF', Update: '#10B981' };

const fmtDate = (d) => d ? new Date(d).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) : null;

const getDuration = (n) => {
    const start = fmtDate(n.startDate);
    const end = fmtDate(n.endDate);
    if (start && end) return `${start} — ${end}`;
    if (start) return `From ${start}`;
    if (end) return `Until ${end}`;
    return null;
};

const DashboardNoticeBoard = ({ notices = [], autoOpenNoticeId }) => {
    const navigate = useNavigate();
    const [selectedNotice, setSelectedNotice] = useState(null);

    // Auto-open notice from notification link (/dashboard?noticeId=123)
    const [autoOpened, setAutoOpened] = React.useState(false);
    React.useEffect(() => {
        if (autoOpenNoticeId && notices.length > 0 && !autoOpened) {
            const target = notices.find(n => n.noticeId === autoOpenNoticeId);
            if (target) { setSelectedNotice(target); setAutoOpened(true); }
        }
    }, [autoOpenNoticeId, notices, autoOpened]);

    const sorted = [...notices]
        .sort((a, b) => (b.isPinned ? 1 : 0) - (a.isPinned ? 1 : 0) || new Date(b.createdOn) - new Date(a.createdOn));

    return (
        <div style={{ background: 'white', borderRadius: 12, padding: 16, boxShadow: '0 1px 3px rgba(0,0,0,0.06)', height: '100%', display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                <h3 style={{ margin: 0, fontSize: 14, fontWeight: 700 }}>Noticeboard</h3>
                <span onClick={() => navigate('/settings/noticeboard')} style={{ color: '#1A8CFF', fontSize: 11, cursor: 'pointer' }}>View All</span>
            </div>
            <div style={{ flex: 1, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 6 }}>
                {sorted.length === 0 ? (
                    <div style={{ color: '#94A3B8', textAlign: 'center', padding: 20, fontSize: 12 }}>No notices</div>
                ) : sorted.slice(0, 5).map(n => (
                    <div
                        key={n.noticeId}
                        onClick={() => n.campaignId ? navigate(`/incentives/${n.campaignId}/detail`) : setSelectedNotice(n)}
                        style={{
                            background: '#f8fafc', borderRadius: 6, padding: '8px 10px', cursor: 'pointer',
                            borderLeft: `3px solid ${CATEGORY_BORDER[n.category] || '#94A3B8'}`,
                            transition: 'background 0.15s',
                        }}
                        onMouseEnter={e => e.currentTarget.style.background = '#f1f5f9'}
                        onMouseLeave={e => e.currentTarget.style.background = '#f8fafc'}
                    >
                        <div style={{ fontSize: 12, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{n.title}</div>
                        <div style={{ fontSize: 10, color: '#94A3B8', marginTop: 2 }}>
                            {getDuration(n) || fmtDate(n.createdOn)} · {n.category}
                        </div>
                    </div>
                ))}
            </div>
            <NoticeDetailModal notice={selectedNotice} open={!!selectedNotice} onClose={() => setSelectedNotice(null)} />
        </div>
    );
};

export default DashboardNoticeBoard;
